import { lowerCase, flow } from "lodash/fp";

/**
 * SVG for Shed & partners
 */
export const APP_ASSETS_SVG_DEFAULT = import.meta.env.BASE_URL + `assets/`;
export const APP_ASSETS_SVG_SHED = APP_ASSETS_SVG_DEFAULT + "shed_orange.svg";
export const APP_ASSETS_SVG_RAINFOREST =
  APP_ASSETS_SVG_DEFAULT + "rainforest_black.svg";

/**
 * SVG for Car
 */
export const CAR_BRAND_SVG_BASE = import.meta.env.BASE_URL + `cars/`;
export const CAR_BRAND_SVG_DEFAULT = CAR_BRAND_SVG_BASE + "car.svg";

export const getCarBrandSvg = (carBrand: string) =>
  import.meta.env.BASE_URL + `cars/${flow(lowerCase)(carBrand)}.svg`;

/**
 * SVG for Map
 */
export const MAP_MARKERS_SVG_BASE = import.meta.env.BASE_URL + `markers/`;
export const MAP_MARKERS_SVG_USER = MAP_MARKERS_SVG_BASE + "user.svg";
export const MAP_MARKERS_PNG_CARDS_BASE = MAP_MARKERS_SVG_BASE + "cards/";
export const MAP_MARKERS_SVG_ICONS_BASE = MAP_MARKERS_SVG_BASE + "icons/";
export const MAP_MARKERS_SVG_PRODUCTS_BASE = MAP_MARKERS_SVG_BASE + "products/";
